import { DadosDepreciacao } from '@/features/laudo/types/laudo-wizard.types';
import { TabelaDepreciacao } from '../TabelaDepreciacao';

interface CalculoDepreciacaoProps {
  dados: DadosDepreciacao[];
  onUpdate: (dados: DadosDepreciacao[]) => void;
  disabled?: boolean;
  displayIdMap?: Record<string, string>;
}

export function CalculoDepreciacao({
  dados,
  onUpdate,
  disabled,
  displayIdMap,
}: CalculoDepreciacaoProps) {
  return <TabelaDepreciacao dados={dados} onUpdate={onUpdate} disabled={disabled} displayIdMap={displayIdMap} />;
}
